var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.704 30",
    enableBackground: "new 0 0 29.704 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M12.51,30c-0.563-0.192-0.752-0.604-0.751-1.174c0.008-4.373-0.003-8.746,0.011-13.119 c0.002-0.699-0.226-1.253-0.698-1.763C7.531,10.121,4.002,6.285,0.47,2.452c-0.642-0.696-0.631-1.574,0.061-2.128 c0.207-0.166,0.506-0.219,0.769-0.31c0.079-0.027,0.174-0.008,0.262-0.008c8.863,0,17.726,0,26.589,0 c0.807,0,1.345,0.374,1.511,1.064c0.126,0.527-0.035,0.972-0.403,1.366c-0.959,1.027-1.908,2.065-2.86,3.098 c-2.613,2.835-5.224,5.671-7.842,8.502c-0.42,0.454-0.618,0.967-0.616,1.588c0.012,2.626-0.004,5.251,0.011,7.877 c0.003,0.619-0.17,1.139-0.578,1.603c-1.319,1.504-2.625,3.02-3.946,4.523c-0.135,0.154-0.337,0.249-0.507,0.372 C12.784,30,12.647,30,12.51,30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.01b2bc233eb714e805fd19cb9aab17d6.svg";
export { ForwardRef as ReactComponent };